var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyncBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50317 13.1373H5.25481V15.7647H3.50317V13.1373Z",
    fill: "#4D5874"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00659 13.1373H8.75823V15.7647H7.00659V13.1373Z",
    fill: "#4D5874"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875732 1.75163C0.875732 0.784233 1.65997 0 2.62737 0H12.2614C13.2288 0 14.013 0.784233 14.013 1.75163V4.37909H12.2614V8.75817H14.013V11.3856C14.013 12.353 13.2288 13.1373 12.2614 13.1373H2.62737C1.65997 13.1373 0.875732 12.353 0.875732 11.3856V1.75163ZM7.88227 3.50327L5.25482 7.00654H7.00645V9.63399L9.6339 6.13072H7.88227V3.50327Z",
    fill: "#4D5874"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1372 5.25494H14.8888V7.88239H13.1372V5.25494Z",
    fill: "#4D5874"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.62744H1.75163V5.25489H0V2.62744Z",
    fill: "#4D5874"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.88232H1.75163V10.5098H0V7.88232Z",
    fill: "#4D5874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncBoxIcon);
export default __webpack_public_path__ + "static/media/sync_box_icon.d046e29185132fd4f1b94e9dda6f1f28.svg";
export { ForwardRef as ReactComponent };